module.exports = __webpack_public_path__ + "static/img/blog-02.1f5078a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/blog-02.jpg
// module id = hMvC
// module chunks = 7